import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";

export function QueryParamsManager() {
    const { activePaginationLimit, activePaginationPage } = useAppSelector(state => state.customerProxyAdminPage);

    const [queryParams, setQueryParams] = useSearchParams();

    const isFirstRender = useRef(true);

    useEffect(() => {
        setQueryParams((params) => {
            if (activePaginationLimit) {
                params.set("limit", String(activePaginationLimit))
            } else {
                params.delete("limit")
            }

            if (activePaginationPage) {
                params.set("page", String(activePaginationPage))
            } else {
                params.delete("page")
            }

            return params
        }, {
            replace: isFirstRender.current
        })

        isFirstRender.current = false;
    }, [activePaginationLimit, activePaginationPage]);

    return <></>
}